module.exports = __webpack_public_path__ + "img/4-c-squoll-participant-nuage-de-mots-md.98b8e5f5.png";